// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'mapValues' is declared but its value is never rea... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { keyBy, mapValues } from "lodash";

import { CRUDAction, IEntityFetchCollectionSuccess, IEntityFetchSuccess, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { ContactFormAction, ContactFormActionNames } from "./actions";
import { IContactForm, ISyncDeleteContactFormPayload } from "./interfaces";

const initialState = {};

export const contactFormsReducer = (
  state: IEntityCollectionState<IContactForm> = initialState,
  action: ContactFormAction
): IEntityCollectionState<IContactForm> => {
  switch (action.type) {
    case ContactFormActionNames[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<IContactForm>;
      return keyBy(values, form => form.id);
    }
    case ContactFormActionNames[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case ContactFormActionNames[CRUDAction.CREATE][RequestAction.SUCCESS]: {
      const { value } = action.payload as IEntityFetchSuccess<IContactForm>;

      return {
        ...state,
        [value.id]: value,
      };
    }
    case ContactFormActionNames.SYNC_DELETE: {
      const { id } = action.payload as ISyncDeleteContactFormPayload;
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: _, ...rest } = state;
      return rest;
    }
    default:
      return state;
  }
};
